import React from 'react';
import Modal from './Modal';
import { Button, ButtonSize, ButtonType } from '@hills-design-system/components';

interface HroInformationModalProps {
  onClose: () => void;
  title?: string;
  description?: string;
  buttonLabel?: string;
  onClick: () => void;
  isOpen?: boolean;
}

const HroInformationModal: React.FC<HroInformationModalProps> = ({
  onClose,
  isOpen = false,
  title,
  description,
  buttonLabel = '',
  onClick,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={''}>
      <div className="flex flex-col gap-60 px-200 pb-300 items-center justify-center">
        <div className="flex flex-col items-center justify-center gap-3 w-[400px]">
          <h3 className="text-heading-150 leading-7 text-center font-bold text-black mb-0">
            {title}
          </h3>
          <p className="font-normal text-center text-gray-500 mb-100">{description}</p>
          <div className="flex justify-center items-center gap-100">
            <Button
              data-id="cta"
              label={buttonLabel}
              type={ButtonType.Primary}
              size={ButtonSize.Small}
              onClick={onClick}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default HroInformationModal;
